<template>
  <section
    id="header"
    class="navigation-wrap start-header"
    :scroll="handleSCroll"
  >
    <nav class="navbar navbar-light p-0 h-100">
      <div class="container-fluid h-100">
        <div
          class="d-flex align-items-center justify-content-between gap-2 w-100"
        >
          <div class="d-flex align-items-center gap-3">
            <div class="sidebar-toggler" @click="toggleSideBar"></div>
            <div class="separator d-block d-md-none d-lg-none"></div>
            <router-link
              v-if="role == 2"
              class="navbar-brand d-inline-block"
              :to="{ name: 'home' }"
              ><img
                :src="require('@/assets/images/logo.png')"
                class="d-inline-block"
                alt=""
            /></router-link>
            <router-link
              v-else-if="role == 3"
              class="navbar-brand-admin"
              :to="{ name: 'home' }"
              ><img
                :src="require('@/assets/images/logo-affiliate.png')"
                class="d-inline-block"
                alt=""
            /></router-link>
            <router-link
              v-else-if="role == 6"
              class="navbar-brand-admin"
              :to="{ name: 'home' }"
              ><img
                :src="require('@/assets/images/logo-trainer.png')"
                class="d-inline-block"
                alt=""
            /></router-link>
            <router-link
              v-else
              class="navbar-brand-admin d-inline-block"
              :to="{ name: 'home' }"
              ><img
                :src="require('@/assets/images/logo-admin.svg')"
                class="d-inline-block"
                alt=""
            /></router-link>
            <div
              v-if="role == 1 || role >= 3"
              class="route-title d-none d-md-block"
            >
              {{ route.meta.title }}
            </div>
            <div
              v-if="role == 2"
              class="separator d-none d-md-block d-lg-block"
            ></div>
            <div v-if="role == 1" class="dropdown">
              <button
                class="btn btn-primary d-none d-md-block"
                data-bs-toggle="dropdown"
                data-bs-target="dropdown-add"
                aria-expanded="false"
              >
                <i class="fa fa-edit mr-2" aria-hidden="true"></i>Buat Produk
              </button>
              <ul class="dropdown-menu" id="dropdown-add">
                <li>
                  <button
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#modalPromo"
                  >
                    Promo
                  </button>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-insight-webinar-add' }"
                    class="dropdown-item text-decoration-none"
                    >Dilatih Insight Produk</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'admin-workshop-add' }"
                    class="dropdown-item text-decoration-none"
                    >Dilatih Workshop Produk</router-link
                  >
                </li>
              </ul>
            </div>
            <router-link
              :to="{ name: 'course' }"
              v-if="role == 2"
              class="btn btn-primary d-none d-md-block d-lg-block"
              aria-expanded="false"
            >
              <i class="fa fa-search me-2" aria-hidden="true"></i>Cari Produk
            </router-link>
          </div>
          <!-- <router-link v-if="role == 1" :to="{ name: 'admin-dashboard' }" class="nav-link" role="button">
            <div v-if="profile.avatar == null" class="avatar-m d-flex align-items-center justify-center">
              {{ initials(profile.fullname) }}
            </div>
            <img v-else :src="profile.avatar" class="avatar-m" />
          </router-link>
          <router-link v-if="role == 2" :to="{ name: 'dashboard' }" class="nav-link" role="button">
            <div v-if="profile.avatar == null" class="avatar-m d-flex align-items-center justify-center">
              {{ initials(profile.fullname) }}
            </div>
            <img v-else :src="profile.avatar" class="avatar-m" />
          </router-link>
          <router-link v-if="role >= 3" :to="{ name: 'affiliate-dashboard' }" class="nav-link" role="button">
            <div v-if="profile.avatar == null" class="avatar-m d-flex align-items-center justify-center">
              {{ initials(profile.fullname) }}
            </div>
            <img v-else :src="profile.avatar" class="avatar-m" />
          </router-link> -->
        </div>
      </div>
    </nav>
  </section>
  <!-- ADD PROMO -->
  <div
    class="modal fade"
    id="modalPromo"
    tabindex="-1"
    aria-labelledby="modalPromo"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalPromo">Add Promo</h5>
        </div>
        <div class="modal-body text-start">
          <div class="form-group mb-4">
            <label for="" class="form-label">Judul</label>
            <input
              v-model="data.create.judul"
              type="text"
              class="form-control"
              placeholder=""
              aria-describedby="helpId"
            />
          </div>
          <div class="form-group mb-4">
            <label for="" class="form-label">Status Promo</label>
            <Multiselect
              placeholder="Choose Something"
              v-model="data.create.status"
              mode="single"
              :searchable="false"
              :options="[0, 1]"
              :single-label="selectedLabel"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
            >
              <template v-slot:singlelabel="{ value }">
                <div class="multiselect-single-label" v-if="value.value == 1">
                  Posted
                </div>
                <div class="multiselect-single-label" v-if="value.value == 0">
                  Hidden
                </div>
              </template>

              <template v-slot:option="{ option }">
                <div v-if="option.value == 1">Posted</div>
                <div v-if="option.value == 0">Hidden</div>
              </template>
            </Multiselect>
          </div>
          <div v-show="data.create.status == 1" class="form-group mb-4">
            <label for="" class="form-label">Caption</label>
            <textarea
              v-model="data.create.caption"
              id=""
              cols="30"
              rows="40"
            ></textarea>
          </div>
          <div v-show="data.create.status == 1" class="form-group mb-4">
            <label for="" class="form-label">Link Tujuan</label>
            <input
              v-model="data.create.hyperlink"
              type="text"
              class="form-control"
              placeholder=""
              aria-describedby="helpId"
            />
          </div>
          <div v-show="data.create.status == 1" class="form-group mb-4">
            <img
              v-bind:class="preview ? 'd-block' : 'd-none'"
              class="banner-promo-preview"
              id="promoPreview"
              :src="require('@/assets/images/hero-bg.png')"
              alt=""
            />

            <label for="" class="form-label d-block"
              >Banner (472px x 316px)</label
            >
            <input
              type="file"
              id="image"
              ref="fileInput"
              class="d-none"
              aria-describedby="helpId"
              @change="promoPreviewToggle"
            />
            <button class="btn btn-primary" @click="$refs.fileInput.click()">
              Browse File
            </button>
          </div>
          <div class="form-group mb-4">
            <label for="" class="form-label">Untuk Produk</label>
            <Multiselect
              placeholder="Choose Something"
              v-model="data.create.status_produk"
              mode="single"
              :searchable="false"
              :options="[1, 2]"
              :single-label="selectedLabel"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
            >
              <template v-slot:singlelabel="{ value }">
                <div class="multiselect-single-label" v-if="value.value == 1">
                  Produk Pilihan
                </div>
                <div class="multiselect-single-label" v-if="value.value == 2">
                  Semua Produk
                </div>
              </template>

              <template v-slot:option="{ option }">
                <div v-if="option.value == 1">Produk Pilihan</div>
                <div v-if="option.value == 2">Semua Produk</div>
              </template>
            </Multiselect>
          </div>
          <div v-show="data.create.status_produk == 1" class="form-group mb-4">
            <label for="" class="form-label">Pilih Produk</label>
            <Multiselect
              v-model="data.create.produk"
              :options="data.webinar"
              mode="tags"
              :close-on-select="false"
              :searchable="true"
              :create-option="true"
            >
            </Multiselect>
          </div>
          <div class="form-group mb-4">
            <label for="" class="form-label">Tipe Promo</label>
            <Multiselect
              placeholder="Choose Something"
              v-model="data.create.status_produk"
              mode="single"
              :searchable="false"
              :options="[0, 1]"
              :single-label="selectedLabel"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
            >
              <template v-slot:singlelabel="{ value }">
                <div class="multiselect-single-label" v-if="value.value == 0">
                  Sekali Pakai
                </div>
                <div class="multiselect-single-label" v-if="value.value == 1">
                  Berulang
                </div>
              </template>

              <template v-slot:option="{ option }">
                <div v-if="option.value == 0">Sekali Pakai</div>
                <div v-if="option.value == 1">Berulang</div>
              </template>
            </Multiselect>
          </div>
          <div v-if="data.create.tipe_promo == 1" class="form-group mb-4">
            <label for="" class="form-label">Kode Promo</label>
            <input
              v-model="data.create.kode"
              type="text"
              class="form-control"
              placeholder="PREMIUM"
              aria-describedby="helpId"
            />
          </div>
          <div v-else class="form-group mb-4">
            <label for="" class="form-label"
              >Jumlah Kupon (Auto Generated CSV)</label
            >
            <input
              v-model="data.create.limit"
              type="text"
              class="form-control"
              placeholder=""
              aria-describedby="helpId"
            />
          </div>
          <div class="form-group mb-4">
            <label for="" class="form-label">Tipe Potongan</label>
            <Multiselect
              placeholder="Choose Something"
              v-model="data.create.tipe_potongan"
              mode="single"
              :searchable="false"
              :options="[0, 1]"
              :single-label="selectedLabel"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
            >
              <template v-slot:singlelabel="{ value }">
                <div class="multiselect-single-label" v-if="value.value == 0">
                  Harga
                </div>
                <div class="multiselect-single-label" v-if="value.value == 1">
                  Persentase
                </div>
              </template>

              <template v-slot:option="{ option }">
                <div v-if="option.value == 0">Harga</div>
                <div v-if="option.value == 1">Persentase</div>
              </template>
            </Multiselect>
          </div>
          <div class="form-group mb-4">
            <label for="" class="form-label">Potongan Harga</label>
            <div class="custom-input-group position-relative w-100">
              <input
                v-model="data.create.potongan"
                v-bind:class="data.create.tipe_potongan == 1 ? 'right' : 'left'"
                type="text"
                class="form-control rounded-5 input-no-shadow white"
                aria-label="Amount (to the nearest dollar)"
              />
              <div
                v-if="data.create.tipe_potongan == 1"
                class="suffix rounded-5"
              >
                <p class="m-0">%</p>
              </div>
              <div v-else class="prefix rounded-5">
                <p class="m-0">Rp</p>
              </div>
            </div>
          </div>

          <div class="form-group mb-4">
            <label for="" class="form-label">Durasi Mulai</label>
            <div class="dropdown">
              <div
                class="custom-input-group position-relative w-100"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                aria-describedby="helpId"
              >
                <input
                  v-model="data.create.durasi_mulai"
                  type="datetime-local"
                  readonly
                  class="form-control right"
                  placeholder=""
                  aria-describedby="helpId"
                />
                <div class="suffix">
                  <i class="fas fa-calendar"></i>
                </div>
              </div>
              <ul
                class="dropdown-menu text-start"
                onclick="event.stopPropagation()"
              >
                <DatePicker
                  v-model="data.range"
                  format="YYYY-MM-dd"
                  mode="dateTime"
                  color="purple"
                >
                </DatePicker>
              </ul>
            </div>
          </div>
          <div class="form-group mb-4">
            <label for="" class="form-label">Durasi Selesai</label>
            <div class="dropdown">
              <div
                class="custom-input-group position-relative w-100"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                aria-describedby="helpId"
              >
                <input
                  v-model="data.create.durasi_selesai"
                  type="datetime-local"
                  readonly
                  class="form-control right"
                  placeholder=""
                  aria-describedby="helpId"
                />
                <div class="suffix">
                  <i class="fas fa-calendar"></i>
                </div>
              </div>
              <ul
                class="dropdown-menu text-start"
                onclick="event.stopPropagation()"
              >
                <DatePicker
                  v-model="data.range"
                  format="YYYY-MM-dd"
                  mode="dateTime"
                  color="purple"
                >
                </DatePicker>
              </ul>
            </div>
          </div>
          <div class="form-group mb-4">
            <label for="" class="form-label">Batas Pemakaian</label>
            <input
              v-model="data.create.limit"
              type="text"
              class="form-control"
              placeholder="Kosongkan jika tidak terbatas"
              aria-describedby="helpId"
            />
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex align-items-center justify-end gap-2 w-100">
            <button
              type="button"
              id="tutup_promo"
              class="btn"
              data-bs-dismiss="modal"
            >
              <i class="fa-solid fa-xmark mr-2"></i>Cancel
            </button>
            <button type="button" @click="add_promo" class="btn btn-primary">
              <i class="fa fa-edit mr-2" aria-hidden="true"></i>Add
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END ADD PROMO -->
</template>
<style src="@vueform/multiselect/themes/default.css"></style>
<script>
import { useStore } from 'vuex'
import { reactive, onMounted, computed, ref } from 'vue'
import Swal from 'sweetalert2'
import { useLoading } from 'vue-loading-overlay'
import { useToast } from 'vue-toastification'
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router'
// import ProfileAvatar from "vue-profile-avatar";
import Multiselect from '@vueform/multiselect'
import { effectiveRole } from '@/utils/viewMode'

export default {
  name: 'HeaderAdminComponent',
  components: {
    // ProfileAvatar,
    Multiselect,
  },
  setup() {
    const store = useStore()
    const toast = useToast()
    const router = useRouter()
    const route = useRoute()
    const $loading = useLoading({})

    const profile = computed(() => {
      return JSON.parse(window.localStorage.getItem('user'))
    })
    // 2 while a staff member views the site as a peserta (utils/viewMode.js).
    const role = computed(() => effectiveRole(profile.value))

    const ip = computed(() => {
      return window.localStorage.getItem('ip')
    })

    const val = ref(profile)

    const data = reactive({
      isLogin: false,
      profile: profile.value.avatar,
      routeTitle: document.title,
      create: {
        status: 1,
        status_produk: 1,
        judul: '',
        caption: '',
        hyperlink: '',
        tipe_promo: 1,
        tipe_potongan: null,
        kode: '',
        potongan: '',
        durasi_mulai: '',
        durasi_selesai: '',
        limit: '',
        image: '',
        produk: [],
      },
    })

    function handleSCroll() {
      let header = document.querySelector('.start-header')
      if (window.scrollY > 80 && !header.className.includes('scroll-on')) {
        header.classList.add('scroll-on')
      } else if (window.scrollY < 80) {
        header.classList.remove('scroll-on')
      }
    }

    function toggleSideBar() {
      let toggler = document.querySelector('.sidebar-toggler')
      let nav = document.querySelector('.l-navbar')
      nav.classList.toggle('show')
      if (nav.className.includes('show')) {
        toggler.classList.add('sidebar-open')
      } else {
        toggler.classList.remove('sidebar-open')
      }
    }

    function logout() {
      Swal.fire({
        icon: 'info',
        title: 'apa anda yakin ingin keluar ?',
        showDenyButton: true,
        confirmButtonText: 'Ya, saya yakin',
        denyButtonText: `Batalkan`,
      }).then((result) => {
        const loader = $loading.show()
        if (result.isConfirmed) {
          let ip_address = ip.value
          store
            .dispatch('auth/logout', {
              ip_address,
            })
            .then(() => {
              toast.success('berhasil logout!')
              loader.hide()
              router.push({ name: 'login' })
              return
            })
            .catch(() => {
              toast.error('internal server error!')
              loader.hide()
              return
            })
        } else if (result.isDenied) {
          loader.hide()
          // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }

    function add_promo() {
      data.create.durasi_mulai = data.create.durasi_mulai.replace('T', ' ')
      data.create.durasi_selesai = data.create.durasi_selesai.replace('T', ' ')
      const image = document.getElementById('image').files[0]

      const reader = new FileReader()
      var rawImg
      reader.onloadend = () => {
        rawImg = reader.result
        data.create.image = rawImg

        const loader = $loading.show()
        store
          .dispatch('promo/add_promo', data.create)
          .then((response) => {
            loader.hide()
            document.getElementById('tutup_promo').click()
            toast.success(response.data.message)
          })
          .catch((error) => {
            loader.hide()
            console.log(error)
          })
      }
      reader.readAsDataURL(image)
    }

    function cek_login() {
      if (store.getters['auth/isLoggedIn']) {
        data.isLogin = true
      }
    }
    onBeforeRouteUpdate((to, from, next) => {
      data.routeTitle = to.meta.title
      next()
    })

    onMounted(() => {
      cek_login()
    })

    return {
      role,
      route,
      add_promo,
      onBeforeRouteUpdate,
      profile,
      logout,
      data,
      handleSCroll,
      toggleSideBar,
      val,
    }
  },
}
</script>
